import { createReducer, Reducer } from "@reduxjs/toolkit";
import { Pageable } from "../../services/pageable";
import { RemoteResource } from "../common/fetchable";
import { EmptyFetchable, Fetchable } from "../common/fetchable/helpers";
import { ChainActions } from "./actions";
import { ChainDTO } from "./models/dto";

export namespace Chain {
  export const allWalletReports: RemoteResource<
    ChainDTO.Responses.GetAllWalletReports.T,
    ChainDTO.Responses.GetAllWalletReports.T,
    Pageable.T<
      Exclude<keyof ChainDTO.Responses.GetSingleWalletReports.T, "riskProfile">
    >
  > = {
    fetch: ChainActions.setAllWalletReportsPagination,
    updateStore: ChainActions.setAllWalletReports,
    selector: (store) => store.chain.allWalletReports.data,
  };
}

/**
 * Interface used for Redux Store
 */
export interface Chain {
  allWalletReports: {
    data: Fetchable<ChainDTO.Responses.GetAllWalletReports.T>;
    pagination: Pageable.T<
      Exclude<keyof ChainDTO.Responses.GetSingleWalletReports.T, "riskProfile">
    >;
  };
  singleWalletReportsMap: Record<
    string,
    ChainDTO.Responses.GetSingleWalletReports.T | "LOADING"
  >;
}

const initialState: Chain = {
  allWalletReports: {
    data: EmptyFetchable,
    pagination: {},
  },
  singleWalletReportsMap: {},
};
// Reducer
export const chainReducer: Reducer<Chain, ChainActions.Actions> = createReducer(
  initialState,
  (builder) => {
    builder
      .addCase(ChainActions.getAllWalletReports, (state) => {
        state.allWalletReports.data = {
          status: "loading",
        };
      })
      .addCase(ChainActions.setAllWalletReportsPagination, (state, action) => {
        state.allWalletReports.pagination = action.payload;
        state.allWalletReports.data = {
          status: "loading",
        };
      })
      .addCase(ChainActions.setAllWalletReports, (state, action) => {
        state.allWalletReports.data = action.payload;
        //TODO: use id as link to map
        if (action.payload.status === "ready") {
          action.payload.data.content.forEach((p) => {
            state.singleWalletReportsMap[p.id] = p;
          });
        }
      })
      .addCase(ChainActions.resetAllWalletReports, (state) => {
        state.allWalletReports.data = EmptyFetchable;
        state.allWalletReports.pagination = {};
      })
      .addCase(ChainActions.setSingleWalletReports, (state, action) => {
        state.singleWalletReportsMap[action.payload.id] = action.payload.result;
      });
  }
);
